<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  preserveAspectRatio="xMinYMin"
  id="floor-plan-canvas"
  width="100%"
  viewBox="0 0 1 1"
  [attr.viewBox]="
    '-400 -400 ' + (floorPlan.Size.X + 600) + ' ' + (floorPlan.Size.Y + 600)
  "
  (mousemove)="mouseMove($event)"
  (mouseup)="mouseUp($event)"
  (touchend)="mouseUp($event)"
  (mousedown)="clickCanvas()"
>
  <defs>
    <clipPath id="room">
      <path
        d="M0 0"
        [attr.d]="getInsideWallsPath()"
        style="stroke: none; stroke-width: 20px; fill: #00a0df"
        stroke-linejoin="round"
        fill-rule="evenodd"
      ></path>
    </clipPath>
  </defs>

  <g class="rulers">
    <g *ngFor="let ruler of wallRulers">
      <g
        class="ruler vertical-ruler"
        *ngIf="ruler.isVertical"
        attr.transform="translate( {{ ruler.svgStart.X }} {{
          ruler.svgStart.Y
        }} )"
      >
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="-ruler.serifSize"
          [attr.x2]="ruler.serifSize"
          y1="0"
          y2="0"
        />
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="-ruler.serifSize"
          [attr.x2]="ruler.serifSize"
          [attr.y1]="-ruler.length"
          [attr.y2]="-ruler.length"
        />
        <line
          class="ruler-line ruler-main-line"
          style="stroke: black; stroke-width: 3px"
          y1="0"
          [attr.y2]="-ruler.length"
          x1="0"
          x2="0"
        />
        <text
          class="ruler-text"
          style="font-size: 50px"
          x="-10px"
          [attr.y]="-ruler.length / 2"
          attr.transform="rotate( -90 0 {{ -ruler.length / 2 }} )"
          text-anchor="middle"
        >
          {{ ruler.length.toFixed(0) }}
        </text>
      </g>

      <g
        class="ruler horizontal-ruler"
        *ngIf="!ruler.isVertical"
        attr.transform="translate( {{ ruler.svgStart.X }} {{
          ruler.svgStart.Y
        }} )"
      >
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          x1="0"
          x2="0"
          [attr.y1]="-ruler.serifSize"
          [attr.y2]="ruler.serifSize"
        />
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="ruler.length"
          [attr.x2]="ruler.length"
          [attr.y1]="-ruler.serifSize"
          [attr.y2]="ruler.serifSize"
        />
        <line
          class="ruler-line ruler-main-line"
          style="stroke: black; stroke-width: 3px"
          x1="0"
          [attr.x2]="ruler.length"
          y1="0"
          y2="0"
        />
        <text
          class="ruler-text"
          style="font-size: 50px"
          y="-10px"
          [attr.x]="ruler.length / 2"
          text-anchor="middle"
        >
          {{ ruler.length.toFixed(0) }}
        </text>
      </g>
    </g>
  </g>

  <g class="background">
    <rect
      width="0"
      height="0"
      style="stroke: black; stroke-width: 4px; fill: #f5f5f5"
      [attr.width]="floorPlan.Size.X"
      [attr.height]="floorPlan.Size.Y"
    ></rect>
    <line
      class="guideline"
      x1="0"
      y1="0"
      x2="0"
      y2="0"
      style="stroke: grey; stroke-width: 6px"
      *ngFor="let line of guidelines"
      [attr.class]="{
        major: line.major,
        minor: !line.major,
        vertical: line.vertical,
        horizontal: !line.vertical,
      }"
      [ngStyle]="{ stroke: line.major ? 'black' : 'grey' }"
      [attr.x1]="line.start.X"
      [attr.y1]="line.start.Y"
      [attr.x2]="line.end.X"
      [attr.y2]="line.end.Y"
    ></line>

    <path
      class="wall-path"
      d="M0 0"
      [attr.d]="getWallsPath()"
      style="stroke: none; stroke-width: 20px; fill: #00a0df"
      stroke-linejoin="round"
      fill-rule="evenodd"
    ></path>

    <path
      class="wall-path inside"
      d="M0 0"
      [attr.d]="getInsideWallsPath()"
      style="stroke: black; stroke-width: 10px; fill: none"
      stroke-linejoin="miter"
    ></path>
  </g>

  <ng-container *ngIf="showCabinets">
    <g
      class="wall"
      *ngFor="let wall of walls"
      [attr.transform]="getWallTransformString(wall)"
    >
      <g
        *ngFor="let item of wall.Items"
        [attr.transform]="getItemTransformString(item)"
        [attr.cabinet]="updateCabinet(item)"
        [attr.product]="updateProduct(item)"
      >
        <g *ngIf="cabinet">
          <g class="cabinet-section">
            <g
              class="cabinet-section-outline"
              *ngFor="let section of cabinet.actualCabinetSections"
              [attr.transform]="getCabinetSectionTransformString(section)"
            >
              <rect
                x="0"
                y="0"
                width="0"
                height="0"
                class="floorplan-cabinet"
                [style]="getOutlineStyle(cabinet, section)"
                [attr.height]="section.Depth"
                [attr.width]="section.Width"
              />
            </g>

            <g
              class="cabinet-section-fill"
              *ngFor="let section of cabinet.actualCabinetSections"
              [attr.transform]="getCabinetSectionTransformString(section)"
            >
              <rect
                x="0"
                y="0"
                width="0"
                height="0"
                class="floorplan-cabinet"
                style="fill: white; stroke: none"
                [attr.height]="section.Depth"
                [attr.width]="section.Width"
              />
            </g>

            <g
              class="cabinet-section-text"
              *ngFor="let section of cabinet.actualCabinetSections"
              [attr.transform]="getCabinetSectionTransformString(section)"
            >
              <g [attr.transform]="getTextRotateTransformString(section)">
                <!-- section number -->
                <text
                  x="0"
                  y="0"
                  font-family="Verdana"
                  font-size="135"
                  text-anchor="middle"
                  (mousedown)="$event.preventDefault()"
                  [attr.x]="getNamePosX(section)"
                  [attr.y]="getNamePosY(section)"
                  [textContent]="getCabinetSectionName(section)"
                ></text>

                <!-- product line name -->
                <text
                  x="0"
                  y="0"
                  font-family="Verdana"
                  font-size="80"
                  text-anchor="middle"
                  (mousedown)="$event.preventDefault()"
                  [attr.x]="getProductLinePosX(section)"
                  [attr.y]="getProductLinePosY(section)"
                  *ngIf="displayProductLine(section)"
                  [textContent]="cabinet.productLine.Name"
                ></text>
              </g>

              <!-- front marker -->
              <text
                x="0"
                y="0"
                font-family="Verdana"
                font-size="60"
                text-anchor="middle"
                (mousedown)="$event.preventDefault()"
                [attr.x]="section.Width / 2"
                [attr.y]="section.Depth - 20"
              >
                {{ translate("floorplan_image_front_marker", "Front") }}
              </text>

              <!-- error triangles -->
              <g
                *ngIf="showErrorTriangles &amp;&amp; displayProductLine(section)"
              >
                <!--blue info triangle-->
                <image
                  x="0"
                  href="assets/images/errorLevels/level5.png"
                  *ngIf="section.cabinet.maxErrorLevel === 5"
                  y="0"
                  width="1"
                  height="1"
                  preserveAspectRatio="none"
                  [attr.width]="errorTriangleSize(section)"
                  [attr.height]="errorTriangleSize(section)"
                  [attr.x]="section.Width - errorTriangleSize(section)"
                />

                <!--yellow warning triangle-->
                <image
                  x="0"
                  href="assets/images/errorLevels/level10.png"
                  *ngIf="section.cabinet.maxErrorLevel === 10"
                  y="0"
                  width="1"
                  height="1"
                  preserveAspectRatio="none"
                  [attr.width]="errorTriangleSize(section)"
                  [attr.height]="errorTriangleSize(section)"
                  [attr.x]="section.Width - errorTriangleSize(section)"
                />

                <!--red error triangle-->
                <image
                  x="0"
                  href="assets/images/errorLevels/level20.png"
                  *ngIf="section.cabinet.maxErrorLevel === 20"
                  y="0"
                  width="1"
                  height="1"
                  preserveAspectRatio="none"
                  [attr.width]="errorTriangleSize(section)"
                  [attr.height]="errorTriangleSize(section)"
                  [attr.x]="section.Width - errorTriangleSize(section)"
                />
              </g>
            </g>
          </g>
        </g>

        <g *ngIf="!cabinet">
          <rect
            x="0"
            y="0"
            width="0"
            height="0"
            class="floorplan-item"
            *ngIf="!product.imageUrl"
            [attr.width]="item.Width"
            [attr.height]="item.Height"
          />

          <image
            x="0"
            y="0"
            width="0"
            height="0"
            href=""
            class="floorplan-item"
            preserveAspectRatio="none"
            *ngIf="product.imageUrl"
            [attr.width]="item.Width"
            [attr.height]="item.Height"
            [attr.href]="product.imageUrl"
          />
        </g>
      </g>
    </g>
  </ng-container>

  <g *ngIf="partitions">
    <g
      class="section"
      *ngFor="let section of partitions.sections"
      [attr.transform]="getPartitionSectionTransformString(section)"
    >
      <g
        class="module"
        *ngFor="let wall of section.walls"
        (mousedown)="clickPartitionWall(wall, $event)"
      >
        <rect
          [attr.x]="wall.posX"
          y="0"
          [attr.width]="wall.width"
          [attr.height]="wall.depth"
          style="stroke: {{
            isModuleSelected(wall) ? 'red' : 'grey'
          }}; stroke-width: {{
            isModuleSelected(wall) ? '10px' : '5px'
          }}; fill: {{
            doesModuleHaveError(wall) ? '#cf8686' : 'silver'
          }};cursor:move"
        ></rect>

        <!-- Draws direction arrow: Coord 32 for X,Y is decided from scale. -->
        <svg
          [attr.x]="wall.posX + wall.width / 2 - 32"
          [attr.y]="wall.depth / 2 - 32"
          fill="navy"
          cursor="move"
        >
          <path
            d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"
            transform="scale(4)"
          ></path>
        </svg>
      </g>

      <g
        class="module"
        *ngFor="let door of section.doors"
        (mousedown)="clickPartitionWall(door, $event)"
        attr.transform="translate(0, {{ getPartitionDoorYOffset(door) }})"
      >
        <!-- Door movement path -->
        <ng-container *ngIf="door.openDirection == 'left'">
          <path
            stroke-width="10px"
            stroke="black"
            attr.d="M{{ door.posX - door.leftSlideExtensionAmount + 5 }} 0 l0 {{
              door.depth
            }}"
          ></path>
          <path
            stroke-width="10px"
            stroke="black"
            stroke-dasharray="20,20"
            attr.d="M{{ door.posX }} {{ door.depth / 2 }} l{{
              -door.leftSlideExtensionAmount
            }} 0"
          />
        </ng-container>
        <ng-container *ngIf="door.openDirection == 'right'">
          <path
            stroke-width="10px"
            stroke="black"
            attr.d="M{{
              door.posX + door.width + door.rightSlideExtensionAmount - 5
            }} 0 l0 {{ door.depth }}"
          ></path>
          <path
            stroke-width="10px"
            stroke="black"
            stroke-dasharray="20,20"
            attr.d="M{{ door.posX + door.width }} {{ door.depth / 2 }} l{{
              door.rightSlideExtensionAmount
            }} 0"
          />
        </ng-container>
        <ng-container *ngIf="door.openDirection == 'both'">
          <path
            stroke-width="10px"
            stroke="black"
            attr.d="M{{ door.posX - door.leftSlideExtensionAmount + 5 }} 0 l0 {{
              door.depth
            }}"
          ></path>
          <path
            stroke-width="10px"
            stroke="black"
            attr.d="M{{
              door.posX + door.width + door.rightSlideExtensionAmount - 5
            }} 0 l0 {{ door.depth }}"
          ></path>
          <path
            stroke-width="10px"
            stroke="black"
            stroke-dasharray="20,20"
            attr.d="M{{ door.posX - door.leftSlideExtensionAmount }} {{
              door.depth / 2
            }} l{{
              door.width +
                door.leftSlideExtensionAmount +
                door.rightSlideExtensionAmount
            }} 0"
          />
        </ng-container>

        <rect
          [attr.x]="door.posX"
          y="0"
          [attr.width]="door.width"
          [attr.height]="door.depth"
          style="stroke: {{
            isModuleSelected(door) ? 'red' : 'grey'
          }}; stroke-width: {{
            isModuleSelected(door) ? '10px' : '5px'
          }}; fill: {{
            doesModuleHaveError(door) ? '#cf8686' : 'silver'
          }};cursor:move"
        ></rect>

        <!-- Draws direction arrow: Coord 32 for X,Y is decided from scale. -->
        <svg
          [attr.x]="door.posX + door.width / 2 - 32"
          [attr.y]="door.depth / 2 - 32"
          fill="navy"
          cursor="move"
        >
          <path
            d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"
            transform="scale(4)"
          ></path>
        </svg>
      </g>

      <g
        class="section-number"
        attr.transform="rotate( {{ -section.rotation }} {{
          section.width / 2 - 120
        }} {{ 21 }} )"
      >
        <rect
          class="section-number-background"
          width="0"
          style="fill: rgba(50, 50, 50, 0.65); pointer-events: none"
          height="0"
          [attr.width]="100"
          [attr.height]="90"
          [attr.x]="section.width / 2 - (80 + 90)"
          [attr.y]="-(70 - 41) / 2 - 10"
        ></rect>
        <text
          class="section-number-text"
          [attr.x]="section.width / 2 - (80 + 40)"
          [attr.y]="(70 - 41) / 2 + 30"
          style="fill: white; font-size: 60px; pointer-events: none"
          text-anchor="middle"
        >
          {{ getPartitionSectionIndex(section) }}
        </text>
      </g>
    </g>

    <g class="profile" *ngFor="let profile of partitions.profiles">
      <rect
        [attr.x]="profile.posX"
        [attr.y]="profile.posY"
        [attr.transform]="getPartitionProfileTranformString(profile)"
        [attr.width]="getPartitionProfileWidth(profile)"
        [attr.height]="partitionJointSize"
        style="fill: black"
      ></rect>
    </g>

    <!-- Origin indicator -->
    <ng-container *ngIf="selectedPartitionSection != undefined && showOrigin">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        [attr.x]="selectedPartitionSection.posX - 40"
        [attr.y]="selectedPartitionSection.posY - 40"
        width="80"
        height="80"
        viewBox="0,0,256,256"
      >
        <g
          fill="none"
          fill-rule="nonzero"
          stroke="none"
          stroke-width="none"
          stroke-linecap="butt"
          stroke-linejoin="none"
          stroke-miterlimit="10"
          stroke-dasharray=""
          stroke-dashoffset="0"
          font-family="none"
          font-weight="none"
          font-size="none"
          text-anchor="none"
          style="mix-blend-mode: normal"
        >
          <path
            transform="scale(9.84615,9.84615)"
            d="M18.40625,4l-6.40625,4v-2.09375c-3.47656,0.49219 -6.15625,3.48438 -6.15625,7.09375c0,1.98828 0.81641,3.79297 2.125,5.09375l-2.71875,2.4375c-1.89844,-1.94922 -3.0625,-4.59766 -3.0625,-7.53125c0,-5.62891 4.31641,-10.23828 9.8125,-10.75v-2.25zM23.8125,13c0,5.62891 -4.31641,10.23828 -9.8125,10.75v2.25l-6.40625,-4l6.40625,-4v2.0625c3.48047,-0.48828 6.15625,-3.44922 6.15625,-7.0625c0,-1.98437 -0.78516,-3.79297 -2.09375,-5.09375l2.6875,-2.4375c1.89844,1.94922 3.0625,4.59766 3.0625,7.53125z"
            id="strokeMainSVG"
            fill="#000000"
            stroke="#000000"
            stroke-width="2"
            stroke-linejoin="round"
          ></path>
          <g
            transform="scale(9.84615,9.84615)"
            fill="#99609d"
            stroke="none"
            stroke-width="1"
            stroke-linejoin="miter"
          >
            <path
              d="M12,0v2.25c-5.49609,0.51172 -9.8125,5.12109 -9.8125,10.75c0,2.93359 1.16406,5.58203 3.0625,7.53125l2.71875,-2.4375c-1.30859,-1.30078 -2.125,-3.10547 -2.125,-5.09375c0,-3.60937 2.67969,-6.60156 6.15625,-7.09375v2.09375l6.40625,-4zM20.75,5.46875l-2.6875,2.4375c1.30859,1.30078 2.09375,3.10938 2.09375,5.09375c0,3.61328 -2.67578,6.57422 -6.15625,7.0625v-2.0625l-6.40625,4l6.40625,4v-2.25c5.49609,-0.51172 9.8125,-5.12109 9.8125,-10.75c0,-2.93359 -1.16406,-5.58203 -3.0625,-7.53125z"
            ></path>
          </g>
        </g>
      </svg>
    </ng-container>
  </g>

  <g
    *ngIf="cabinetDragInfo &amp;&amp; cabinetDragInfo.snapOutline"
    [attr.transform]="cabinetDragInfo.snapOutline.svgTransformString"
  >
    <g *ngIf="cabinetDragInfo.cabinet">
      <rect
        *ngFor="let cs of cabinetDragInfo.cabinet.cabinetSections"
        transform="translate(0 0)"
        attr.transform="{{ getCabinetSectionTransformString(cs) }}"
        width="0"
        height="0"
        [attr.width]="cs.Width"
        [attr.height]="cs.Depth"
      ></rect>
    </g>
    <g *ngIf="!cabinetDragInfo.cabinet">
      <rect
        *ngIf="!cabinetDragInfo.product.imageUrl"
        class="snap-outline"
        [attr.width]="cabinetDragInfo.snapOutline.size.Y"
        [attr.height]="cabinetDragInfo.snapOutline.size.X"
      />

      <image
        *ngIf="cabinetDragInfo.product.imageUrl"
        class="snap-outline"
        x="0"
        y="0"
        width="0"
        height="0"
        preserveAspectRatio="none"
        [attr.width]="cabinetDragInfo.snapOutline.size.Y"
        [attr.height]="cabinetDragInfo.snapOutline.size.X"
        [attr.href]="cabinetDragInfo.product.imageUrl"
      />
    </g>
  </g>

  <g class="drag-overlays">
    <rect
      *ngFor="let overlay of dragOverlays"
      x="0"
      y="0"
      width="0"
      height="0"
      [attr.width]="overlay.width"
      [attr.height]="overlay.height"
      [attr.transform]="overlay.svgTransformString"
      (mousedown)="
        clickItem(overlay.item, overlay.wall, $event, overlay.section)
      "
      (touchstart)="
        clickItem(overlay.item, overlay.wall, $event, overlay.section)
      "
      (touchmove)="mouseMove($event)"
      style="fill: rgba(255, 0, 0, 0); cursor: move"
    ></rect>
  </g>

  <g *ngIf="showMeasurements">
    <g *ngFor="let measurement of measurements">
      <!-- Arrow -->
      <g
        class="arrow-horizontal"
        *ngIf="measurement.withinFloorPlan && measurement.horizontal"
      >
        <path
          stroke="#b328d0"
          stroke-width="10"
          fill="transparent"
          attr.d="M {{ measurement.line.start!.X }},{{
            measurement.line.start!.Y
          }}
                                m 50,-50 l -50,50 l 50,50 m -50,-50
                                L {{ measurement.line.end!.X }},{{
            measurement.line.end!.Y
          }}
                                m -50,-50 l 50,50 l -50,50"
        />
      </g>
      <g
        class="arrow-vertical"
        *ngIf="measurement.withinFloorPlan && !measurement.horizontal"
      >
        <path
          stroke="#b328d0"
          stroke-width="10"
          fill="transparent"
          attr.d="M {{ measurement.line.start!.X }},{{
            measurement.line.start!.Y
          }}
                                m -50,50 l 50,-50 l 50,50 m -50,-50
                                L {{ measurement.line.end!.X }},{{
            measurement.line.end!.Y
          }}
                                m -50,-50 l 50,50 l 50,-50"
        />
      </g>

      <!-- Drag handle -->
      <g>
        <rect
          width="300"
          height="100"
          [attr.x]="measurement.posX - 150"
          [attr.y]="measurement.posY - 40"
          style="fill: rgba(50,50,50,0.65); margin: auto; padding: 6px 12px; cursor: move; stroke: {{
            isMeasurementSelected(measurement) ? 'red' : 'transparent'
          }}; stroke-width: 10px;"
          (mousedown)="clickMeasurement(measurement, $event)"
        ></rect>
        <text
          width="300"
          height="100"
          [attr.x]="measurement.posX"
          [attr.y]="measurement.posY + 30"
          style="font-size: 60px; fill:white; text-align: center; margin: auto; padding: 6px 12px; cursor: move; border: 10px solid {{
            isMeasurementSelected(measurement) ? 'red' : 'transparent'
          }};"
          (mousedown)="clickMeasurement(measurement, $event)"
          text-anchor="middle"
        >
          {{ round(measurement.length) }}
        </text>
      </g>
    </g>
  </g>
</svg>
